export default __webpack_public_path__ + "static/media/give4.ff3c59aa.PNG";